import { render, staticRenderFns } from "./OtpVerificationPage.vue?vue&type=template&id=36f17509"
import script from "./OtpVerificationPage.vue?vue&type=script&lang=js"
export * from "./OtpVerificationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports